<template>
    <div>
        <b-tabs class="simple-tabs" content-class="simple-tabs-body" v-model="tabIndex">
            <b-tab :title="$t('sign-in.login-tab')" active>
                <GenericTitle :title="getUserFound ? $t('sign-in.main-title-after-user') : $t('sign-in.main-title')"
                              :titleStrong="getUserFound ? (getUserFullName !== undefined ? getUserFullName : '') : $t('sign-in.main-title-strong')"
                              :subtitle="getUserFound ? $t('sign-in.subtitle-after-user') : $t('sign-in.subtitle')"></GenericTitle>

                <b-alert id="loginBlocked" class="alert-note" show variant="danger" v-if="getLoginBlocked">
                    <p class="text-container"><img class="img-fluid"
                                                   src="@/assets/images/Icons/Alerts-icons/icon-alert-error.svg"
                                                   alt=""/>{{$t('sign-in.login-blocked')}}</p>
                </b-alert>

                <b-alert id="signinDataWrong" class="alert-note" show variant="danger" v-if="getLoginAlert">
                    <p class="text-container"><img class="img-fluid"
                                                   src="@/assets/images/Icons/Alerts-icons/icon-alert-error.svg"
                                                   alt=""/>{{getLoginAlertMessage !== "" ? getLoginAlertMessage :
                        $t('sign-in.login-incorrect-data')}}</p>
                </b-alert>
                <BasicInput
                        v-show="!getUserFound"
                        required
                        inputType="text"
                        labelFor="txt-emailSignIn"
                        inputId="txt-emailSignIn"
                        :label="$t('sign-in.email-label')"
                        :inputPlaceholder="$t('sign-in.email-placeholder')"
                        v-on:basicInput="onBasicInputLogin"
                ></BasicInput>
                <UploadProfileImage
                        v-show="getUserFound"
                        :imgUser="getImageById(getUserImageId)"
                        imgUploaded
                        showInfoUser
                        clazz="horizontal-info sm user-verification-login m-b-30"
                        :userName="getUserPhrase">
                </UploadProfileImage>
                <PasswordInput
                        required
                        v-if="getUserFound"
                        :inputType="passwordInputType"
                        labelFor="txt-passwordSignIn"
                        inputId="txt-passwordSignIn"
                        :label="$t('sign-in.password-label')"
                        :hasLevelBar="false"
                        :isVisibleText="isVisibleTextPasswordSignIn"
                        :inputPlaceholder="$t('sign-in.password-placeholder')"
                        @enterKey="login"
                        v-on:passwordInput="onPasswordChangeLogin"
                        v-on:passwordInputType="changeTypePassword">
                </PasswordInput>
                <button id="btn-signInDefault" v-if="!getIsLoadingLogin && !getUserFound"
                        class="button xs button-filled button-accent1 m-t-40 m-b-20 w-100"
                        :class="{'button-disable':disabledUserFound}" type="submit" :disabled="disabledUserFound"
                        @click.prevent="getUserByEmail"> {{$t('sign-in.login-button')}}
                </button>
                <a id="recoveryPassword" @click="goRecoveryPassword()"
                   class="f-16 c-accent_2 body-font-bold text-underline d-block text-align-c m-b-40 hover" tabindex="">
                    {{$t('sign-in.forgot-password')}} </a>

                <div class="d-flex justify-content-between m-t-150 m-b-40"
                     v-if="!getIsLoadingLogin && getUserFound">
                    <button id="btn-comeBack" class="button xs button-ghost button-plain_text m-r-10"
                            @click.prevent="comeBackUserSearch"><i aria-hidden="true" class="banana banana-chevron-left"></i> REGRESAR
                    </button>
                    <button id="btn-loginDefault" :class="{'button-disable':disabledSignIn}"
                            class="button sm button-filled button-accent1" :disabled="disabledSignIn"
                            @click.prevent="login">CONTINUAR
                    </button>
                </div>
                <button type="button" v-if="getIsLoadingLogin"
                        class="button xs button-filled button-accent1 m-b-40 w-100">
                    <LoadingSimple clazz="small-load no-text"/>
                </button>
            </b-tab>
        </b-tabs>
        <!-- Modal for showing 'info-section' on responsive -->
        <b-modal id="modal-info-responsive" hide-header hide-footer>
            <button
                    id
                    class="button-circle sm button-stroke button-info_text m-0-0-0-auto"
                    @click="$bvModal.hide('modal-info-responsive')"
                    type="button"
            >
                <i aria-hidden="true" class="banana banana-cross-normal"></i>
            </button>
            <SignInBody :rightSide="getRightSide" hideRightWizard/>
        </b-modal>

        <ModalAlert
            modalId="modal-sessions"
            buttonType="button-accent1"
            :title="$t('sign-in.modal.title', {qty: getActiveSessions})"
            :text="$t('sign-in.modal.text')"
            :buttonText="$t('general.actions.accept')"
            closeCross
            closeEsc
            closeBackdrop
            noCancelButton
            withAutomaticLoad
            @submit="agreeCloseSessions"
        ></ModalAlert>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import SignInBody from "@/components/SignInBody.vue";
    import GenericTitle from "@/components/GenericTitle.vue";
    import BasicInput from "@/components/BasicInput.vue";
    import PasswordInput from "@/components/PasswordInput.vue";
    import LoadingSimple from "@/components/LoadingSimple.vue";
    import UploadProfileImage from "@/components/UploadProfileImage.vue";
    import ModalAlert from '@/components/ModalAlert.vue';
    import {securityImages} from '@/enums/securityImages';
    import {
        STORE as SESSION_STORE,
        GET_USER
    } from '@/store/modules/session/session.types';
    import {
        STORE as UserSignUpStore
    } from '@/store/modules/signin/signin.types'
    import usersApi from '@/api/user/users.api';
    import ToastSnotify from '@/mixins/toastSnotify.mixin';
    // eslint-disable-next-line max-len
    const regexEmailPhone = /^(?:\+?\d{10,12}$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

    export default {
        name: "SignIn",
        mixins: [ToastSnotify],
        data() {
            return {
                tabIndex: 1,
                registerEmail: '',
                loginEmail: '',
                correctEmail: false,
                correctEmailLogin: false,
                registerPassword: '',
                loginPassword: '',
                error: '',
                clazzPasswordStatus: '',
                labelPasswordStatus: '',
                passwordInputType: 'password',
                passwordInputTypeRegister: 'password',
                checkedTerms: false,
                showStatusBar: false,
                hideButtonLoading: true,
                isVisibleTextPasswordSignIn: false,
                isVisibleTextPasswordRegister: false,
                securityImages: securityImages,
                verificationCode: '',
                verificationError: false,
                verificationErrorText: '',
                verified: false
            }
        },
        props: {
            loginLeftFooter: {type: Boolean, default: false},
            registerLeftFooter: {type: Boolean, default: false}
        },
        created() {
            this.$store.commit(`${UserSignUpStore}/SET_RIGHT_SIDE_BODY`, 'EASY_PAY');
            // Guarda en la sesión los datos para redirigir después del login
            if (this.$route.query.app) {
                this.$session.set('app', this.$route.query.app);
            }
            if (this.$route.query.path) {
                this.$session.set('path', this.$route.query.path);
            }
            if (this.$route.query.message) {
                this.$store.commit(`${UserSignUpStore}/setLoginAlert`, true)
                this.$store.commit(`${UserSignUpStore}/setLoginAlertMessage`, this.$route.query.message)
            }
        },
        mounted() {
        },
        components: {
            SignInBody,
            GenericTitle,
            BasicInput,
            PasswordInput,
            LoadingSimple,
            UploadProfileImage,
            ModalAlert
        },
        methods: {
            goToLanding() {

                if (this.getIsOwner) {
                    this.$store.commit(`${UserSignUpStore}/CLEAR_STORE`);
                    this.$router.push({name: "dashboard"})
                } else {
                    this.$store.commit(`${UserSignUpStore}/CLEAR_STORE`);
                    this.$router.push({name: "SignUpOrganizations"})
                }

            },
            comeBackUserSearch() {
                localStorage.removeItem('currentUser');
                localStorage.removeItem('currentToken');
                localStorage.removeItem('currentPermissions');
                localStorage.removeItem('profile');
                localStorage.removeItem('expireDate');
                usersApi.logout({});
                this.$store.commit(`${UserSignUpStore}/CLEAR_STORE`);
            },
            onBasicInputLogin(email) {
                this.correctEmailLogin = regexEmailPhone.test(email);
                this.loginEmail = email;
            },

            onPasswordChangeLogin(password) {
                this.loginPassword = password;
            },

            changeTypePassword(isVisibleOn) {
                if (isVisibleOn) {
                    this.passwordInputType = 'password';
                } else {
                    this.passwordInputType = 'text';
                }
            },
            login() {
                const credentials = {
                    email: this.loginEmail,
                    password: this.loginPassword
                }
                this.hideButtonLoading = false;
                this.$store.dispatch(`${UserSignUpStore}/login`, {credentials});
            },
            getUserByEmail() {
                const data = {
                    email: this.loginEmail
                }
                this.hideButtonLoading = false;
                this.$store.dispatch(`${UserSignUpStore}/getUserByEmail`, data);
            },
            getImageById(id) {
                let src = undefined;
                this.securityImages.forEach(i => {
                    if (i.id === id) {
                        src = i.src
                    }
                })
                return src;
            },
            goRecoveryPassword() {
                this.$router.push({name: 'SigninPasswordRecovery'});
            },
            agreeCloseSessions(){
                usersApi.disableAccess().then(() => {
                    this.$store.dispatch(`${UserSignUpStore}/agreeCloseSessions`);
                }).catch(error => this.toastErrorDefault(error));
            }
        },
        computed: {
            disabledUserFound() {
                return !(this.correctEmailLogin);
            },
            disabledSignIn() {
                return !(this.loginPassword.length >= 6 && this.correctEmailLogin);
            },
            ...mapGetters(UserSignUpStore, [
                "getShowAlert",
                "getAlertMessage",
                "getIsLoadingRegister",
                "getAlertVariant",
                "getLoginBlocked",
                "getLoginAlert",
                "getLoginAlertMessage",
                "getIsLoadingLogin",
                "getRightSide",
                "getUserFound",
                "getUserPhrase",
                "getUserImageId",
                "getUserFullName",
                "getUserPhone",
                "getIsOwner",
                "getSessionModal",
                "getActiveSessions"
            ]),
            ...mapGetters(SESSION_STORE, {
                actualUser: GET_USER
            }),
        },
        beforeDestroy() {
            this.$store.commit(`${UserSignUpStore}/CLEAR_STORE`);
        },
        watch: {
            getSessionModal(){
                if(this.getSessionModal){
                    this.$bvModal.show('modal-sessions');
                } else {
                    this.$bvModal.hide('modal-sessions');
                }
            }
        }
    }
</script>
